$(window).on("load", function() {
    if ($("#swiperNews").length > 0 && $(window).width() > 768) {
        new Swiper("#swiperNews", {
            slidesPerView: 5,
            // centeredSlides: true,
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-button-next--swiperNews",
                prevEl: ".swiper-button-prev--swiperNews",
            },
        });
    }
});